import _objectSpread from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { getNativeContext } from '../helpers/get-native-context';
var DEFAULT_OPTIONS = {
  channelCount: 2,
  channelCountMode: 'max',
  channelInterpretation: 'speakers',
  fftSize: 2048,
  maxDecibels: -30,
  minDecibels: -100,
  smoothingTimeConstant: 0.8
};
export var createAnalyserNodeConstructor = function createAnalyserNodeConstructor(createAnalyserNodeRenderer, createIndexSizeError, createNativeAnalyserNode, isNativeOfflineAudioContext, noneAudioDestinationNodeConstructor) {
  return (
    /*#__PURE__*/
    function (_noneAudioDestination) {
      _inherits(AnalyserNode, _noneAudioDestination);

      function AnalyserNode(context) {
        var _this;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;

        _classCallCheck(this, AnalyserNode);

        var nativeContext = getNativeContext(context);

        var mergedOptions = _objectSpread({}, DEFAULT_OPTIONS, options);

        var nativeAnalyserNode = createNativeAnalyserNode(nativeContext, mergedOptions);
        var analyserNodeRenderer = isNativeOfflineAudioContext(nativeContext) ? createAnalyserNodeRenderer() : null;
        _this = _possibleConstructorReturn(this, _getPrototypeOf(AnalyserNode).call(this, context, 'passive', nativeAnalyserNode, analyserNodeRenderer));
        _this._nativeAnalyserNode = nativeAnalyserNode;
        return _this;
      }

      _createClass(AnalyserNode, [{
        key: "getByteFrequencyData",
        value: function getByteFrequencyData(array) {
          this._nativeAnalyserNode.getByteFrequencyData(array);
        }
      }, {
        key: "getByteTimeDomainData",
        value: function getByteTimeDomainData(array) {
          this._nativeAnalyserNode.getByteTimeDomainData(array);
        }
      }, {
        key: "getFloatFrequencyData",
        value: function getFloatFrequencyData(array) {
          this._nativeAnalyserNode.getFloatFrequencyData(array);
        }
      }, {
        key: "getFloatTimeDomainData",
        value: function getFloatTimeDomainData(array) {
          this._nativeAnalyserNode.getFloatTimeDomainData(array);
        }
      }, {
        key: "fftSize",
        get: function get() {
          return this._nativeAnalyserNode.fftSize;
        },
        set: function set(value) {
          this._nativeAnalyserNode.fftSize = value;
        }
      }, {
        key: "frequencyBinCount",
        get: function get() {
          return this._nativeAnalyserNode.frequencyBinCount;
        }
      }, {
        key: "maxDecibels",
        get: function get() {
          return this._nativeAnalyserNode.maxDecibels;
        },
        set: function set(value) {
          // Bug #118: Safari does not throw an error if maxDecibels is not more than minDecibels.
          var maxDecibels = this._nativeAnalyserNode.maxDecibels;
          this._nativeAnalyserNode.maxDecibels = value;

          if (!(value > this._nativeAnalyserNode.minDecibels)) {
            this._nativeAnalyserNode.maxDecibels = maxDecibels;
            throw createIndexSizeError();
          }
        }
      }, {
        key: "minDecibels",
        get: function get() {
          return this._nativeAnalyserNode.minDecibels;
        },
        set: function set(value) {
          // Bug #118: Safari does not throw an error if maxDecibels is not more than minDecibels.
          var minDecibels = this._nativeAnalyserNode.minDecibels;
          this._nativeAnalyserNode.minDecibels = value;

          if (!(this._nativeAnalyserNode.maxDecibels > value)) {
            this._nativeAnalyserNode.minDecibels = minDecibels;
            throw createIndexSizeError();
          }
        }
      }, {
        key: "smoothingTimeConstant",
        get: function get() {
          return this._nativeAnalyserNode.smoothingTimeConstant;
        },
        set: function set(value) {
          this._nativeAnalyserNode.smoothingTimeConstant = value;
        }
      }]);

      return AnalyserNode;
    }(noneAudioDestinationNodeConstructor)
  );
};